import React from 'react';

import { ClaudeIcon } from '@atlassian/logo-third-party/claude';
import { CursorIcon } from '@atlassian/logo-third-party/cursor';

import { RovoTileIcon } from '../teamwork-graph-preview-panel/RovoTileIcon.tsx';

import type { BylineConnectionIcon } from './getBylineConnectionIcons.ts';

const claude: BylineConnectionIcon = {
	key: 'Claude',
	label: 'Claude',
	icon: {
		kind: 'logo',
		key: 'Claude',
		label: 'Claude',
		node: <ClaudeIcon label="" size="xxsmall" testId="byline-connections-claude-icon" />,
	},
};

const cursor: BylineConnectionIcon = {
	key: 'Cursor',
	label: 'Cursor',
	icon: {
		kind: 'logo',
		key: 'Cursor',
		label: 'Cursor',
		node: <CursorIcon label="" size="xxsmall" testId="byline-connections-cursor-icon" />,
	},
};

const rovo: BylineConnectionIcon = {
	key: 'Rovo',
	label: 'Rovo',
	icon: {
		kind: 'logo',
		key: 'Rovo',
		label: 'Rovo',
		node: <RovoTileIcon size="xxsmall" />,
	},
};

export const getFallbackConnectionIcons = (
	icons: BylineConnectionIcon[],
	count: number,
): BylineConnectionIcon[] => {
	// With no usable connection icons, match the existing Share context with AI entry.
	const fallbacks = icons.length === 0 ? [rovo, claude, cursor] : [claude, cursor, rovo];
	const existingProducts = new Set(
		icons.flatMap(({ key, label }) => [key.toLowerCase(), label.toLowerCase()]),
	);
	return fallbacks.filter(({ key }) => !existingProducts.has(key.toLowerCase())).slice(0, count);
};
